import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AppointmentForm from './AppointmentForm';

const NewAppointment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultPatientId = searchParams.get('patientId') || undefined;
  const defaultDate = searchParams.get('date') || undefined;

  const handleSuccess = () => {
    // Redirect to appointments list after successful creation
    navigate('/appointments');
  };

  const handleCancel = () => {
    // Go back to previous page
    navigate(-1);
  };

  return (
    <AppointmentForm
      appointment={null}
      isModal={false}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
      defaultPatientId={defaultPatientId}
      defaultDate={defaultDate}
    />
  );
};

export default NewAppointment;
